var text_field_default = {
  "root": "_8TwSj",
  "text": "D3yfM",
  "input": "p-JRC",
  "small": "rlGfC",
  "medium": "_1YfFT",
  "large": "V4nrv",
  "webview": "FnEb1",
  "endAdornment": "n-5vZ",
  "shown": "_6YT7p",
  "value": "pyDxI",
  "spinner": "T5Eh7",
  "spin": "_8rzf8"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
